function toNumberWithoutCommas(num: string | number): string {
  return num.toString().replace(/,\s?/g, '');
}
export default toNumberWithoutCommas;